import { NumberUtils } from "neo-common";
import { Scaling } from "./Scaling";
import { GameManager } from "../Managers/GameManager";
import { Communication } from "neo-games";
import { DataManager } from "../Managers/DataManager";
import { GameData } from "../Channels/Common/Datas/GameData";

/**
 * @class CustomUtils
 * @author Marek Turkovic
 * 25.10.2019
 * todo Implement not only on baseResponse, but freespinsRespons etc..
 */
var WinType = Communication.Game.WinType;

export class CustomUtils {
    public static hasFeatureGame(): boolean {
        if (GameManager.baseResponse && GameManager.baseResponse.wins && GameManager.baseResponse.wins.length > 0) {
            for (let i = 0; i < GameManager.baseResponse.wins.length; i++) {
                let win = GameManager.baseResponse.wins[i];

                if (
                    win.trigger == Communication.Game.WinTrigger.Scatter &&
                    win.type == Communication.Game.WinType.Feature
                ) {
                    if (win.customData["miniGameSymbols"]) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    public static getBaseCurrentWin(withoutFeatureWin: boolean = false): number {
        let currentWin = GameManager.baseResponse.currentWin;

        if (CustomUtils.hasFeatureGame() && withoutFeatureWin) {
            if (GameManager.baseResponse && GameManager.baseResponse.wins.length > 0) {
                for (let i = 0; i < GameManager.baseResponse.wins.length; i++) {
                    let win = GameManager.baseResponse.wins[i];

                    if (
                        win.trigger == Communication.Game.WinTrigger.Scatter &&
                        win.type == Communication.Game.WinType.Feature
                    ) {
                        currentWin = parseFloat(NumberUtils.subtract(currentWin, win.amount));
                    }
                }
            }
        }

        return currentWin;
    }

    public static getBlendMode(blendMode: number): number {
        if (Scaling.IsIOs) {
            if (blendMode == 1) {
                blendMode = 3;
            }
        }

        return blendMode;
    }

    public static updateSpineData(spineData: JSON): JSON {
        if (Scaling.IsIOs) {
            if (spineData != null) {
                let spineTextData = JSON.stringify(spineData);
                spineTextData = spineTextData.split('"blend":"additive"').join('"blend":"screen"');
                spineData = JSON.parse(spineTextData);
            }
        }

        return spineData;
    }

    public static isRetrigger(): boolean {
        if (
            GameManager.freespinsResponse != null &&
            GameManager.freespinsResponse.wins != null &&
            GameManager.freespinsResponse.wins.length > 0
        ) {
            for (let i: number = 0; i < GameManager.freespinsResponse.wins.length; i++) {
                if (GameManager.freespinsResponse.wins[i].type === WinType.freeSpins) {
                    return true;
                }
            }
        }

        return false;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Utils/CustomUtils.ts
 **/